import { Box, Grid } from '@mui/material';
import KpiCard from '../../../../components/ui/kpiCard';

export function RevenueKpis() {
    return (
        <Box><Grid container spacing={3} mb={4}>
            <Grid item xs={12} sm={6} md={3}>
                <KpiCard title="CA brut" value="9 200 000 FCFA" />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <KpiCard title="Commissions" value="750 000 FCFA" />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <KpiCard title="CA net" value="8 450 000 FCFA" />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <KpiCard title="Remboursements" value="120 000 FCFA" />
            </Grid>
        </Grid></Box>

    );
}
